import axios from "axios";

/**
 * Servicio de token exchange / refresh contra Identity.
 *
 * Usa una instancia de axios "desnuda" (sin los interceptors de apiClient) para
 * evitar bucles: el interceptor de respuesta de apiClient llama a refresh() ante
 * un 401, y refresh() no debe volver a pasar por ese mismo interceptor.
 *
 * Endpoint único: POST {REACT_APP_API_AUTH}/auth/token
 *   - grant_type "token_exchange" → intercambia el JWT de Teamsystem (subject_token)
 *   - grant_type "refresh_token"  → renueva el access_token con el refresh_token
 * Ambos devuelven { access_token, refresh_token }.
 */

const API_AUTH = process.env.REACT_APP_API_AUTH;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;

const TOKEN_URL = `${API_AUTH}/auth/token`;

const rawClient = axios.create({
  headers: {"Content-Type": "application/json"}
});

/**
 * Intercambia el access_token de Teamsystem por los tokens internos de Identity.
 * @param {string} subjectToken JWT de Teamsystem.
 * @returns {Promise<{access_token: string, refresh_token: string}>}
 */
export const exchangeToken = async (subjectToken) => {
  if (!subjectToken) throw new Error("exchangeToken: subject_token requerido");

  const {data} = await rawClient.post(TOKEN_URL, {
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    grant_type: "token_exchange",
    subject_token: subjectToken
  });

  return data;
};

/**
 * Renueva el access_token de Identity usando el refresh_token.
 * @param {string} refreshToken
 * @returns {Promise<{access_token: string, refresh_token: string}>}
 */
export const refreshAccessToken = async (refreshToken) => {
  if (!refreshToken) throw new Error("refreshAccessToken: refresh_token requerido");

  const {data} = await rawClient.post(TOKEN_URL, {
    client_id: CLIENT_ID,
    client_secret: CLIENT_SECRET,
    grant_type: "refresh_token",
    refresh_token: refreshToken
  });

  return data;
};
